import React, {useState} from 'react';
import styles from "./GrowthDetail.module.scss";
import BarGraph from '../graph/BarGraph';
import { formatNumberWithDot, imageLink } from '../../../hooks/utils';

const GrowthDetail = ({item, radioboxSelected, showCompareButton, handleCompare}) =>{

    const [display, setDisplay] = useState(false);

    const countryName = item.country;
    const value = item[radioboxSelected] + '%';
    const barWidth = Math.abs(item[radioboxSelected]);
    const barLeftWidth = item[radioboxSelected] < 0 ? barWidth: 0;
    const barRightWidth = item[radioboxSelected] > 0 ? barWidth : 0;

    const compareButton = showCompareButton === true ? 
                        (<button className={styles.compareButton} onClick={handleCompare}>COMPARE WITH W10</button>)
                        : null;
    const urlText = item.urlText ? item.urlText : `Apply for residence in ${countryName}`;
    const url = item.url ? (<p className="mt-auto mb-0">{urlText} <a href={item.url} target="_blank" rel="noreferrer" className="text-underline">here</a></p>) : (<p className="mt-auto mb-0">&nbsp;</p>);

    const handleToggle =() =>{
        setDisplay(!display);
    }


    return(
      <>
       <tr className={`${styles.tableRow} ${styles.cursor} ${display && styles.tableRowHighlight}`} onClick={handleToggle}>
            <td className={styles.nameCol}>{countryName}</td>
            <td className={styles.barLeftCol}>
                <BarGraph barWidth={barLeftWidth} direction="left" barWrapperBackground={display ? '#F7F7F7': '#FFF'} />
            </td>
            <td className={styles.barRightCol}>
                <BarGraph barWidth={barRightWidth} barWrapperBackground={display ? '#F7F7F7': '#FFF'} />
            </td>
            <td className={styles.valCol}>{value}</td>
        </tr>
        {display &&
        <tr className={`${styles.tableRow} ${display && styles.tableRowHighlight}`} >
            <td colSpan={4} className={`${styles.detailCol} p-0`}>
                <table className={styles.detailTable}>
                    <tbody>
                        <tr>
                            <td className={styles.imageCol}>
                                <div className={styles.countryImageWrapper}>
                                    <img src={imageLink(countryName)} alt={countryName} />
                                </div>
                            </td>
                            <td className={styles.countryInfo}>
                                <div className="row">
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">Population (m)</h5>
                                        <h3>{formatNumberWithDot(item.population)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">GDP per capita (USD)</h5>
                                        <h3>{formatNumberWithDot(item.GDPPerCapita)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">Wealth per capita (USD)</h5>
                                        <h3>{formatNumberWithDot(item.wealthPerCapita)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">Total private wealth (USD bn)</h5>
                                        <h3>{formatNumberWithDot(item.totalWealth)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">HNWIs (USD 1m+)</h5>
                                        <h3>{formatNumberWithDot(item.HNWIs)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">Multi-millionaires (USD 10m+)</h5>
                                        <h3>{formatNumberWithDot(item.multiMillionaires)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">Centi-millionaires (USD 100m+)</h5>
                                        <h3>{formatNumberWithDot(item.centiMillionaires)}</h3>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <h5 className="field mb-0">Billionaires (USD 1bn+)</h5>
                                        <h3>{formatNumberWithDot(item.billionaires)}</h3>
                                    </div>
                                </div>
                                <div className="row align-items-center">
                                    <div className="col">
                                        {url}
                                        
                                    </div>
                                    <div className="col text-right">
                                        {compareButton}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        }
      </>
    )
}

export default GrowthDetail;